export default "__VITE_ASSET__BllVDj9Y__"